import { Skeleton } from "../../ui/skeleton";

interface ProductVersionProps {
  version: string | null;
  loading: boolean;
  label: string;
}

export default function ProductVersion({
  version,
  loading,
  label,
}: ProductVersionProps) {
  if (loading) {
    return (
      <span
        className="product-version-loading"
        role="status"
        aria-label={`Loading ${label}`}
      >
        <Skeleton className="product-version-skeleton" />
      </span>
    );
  }

  const availableVersion = version && version !== "N/A" ? version : null;

  return (
    <span
      className="product-version"
      aria-label={`${label}: ${availableVersion || "Unavailable"}`}
    >
      {availableVersion ? `v${availableVersion}` : "Unavailable"}
    </span>
  );
}
